exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".string[data-v-17a18344]{color:green}.number[data-v-17a18344]{color:darkorange}.boolean[data-v-17a18344]{color:blue}.null[data-v-17a18344]{color:magenta}.key[data-v-17a18344]{color:red}\n", ""]);

